import React from "react";
import { Link } from "react-router-dom";
import { useLang } from "../context/LanguageContext";
import { useCart } from "../context/CartContext";
import ProductCard from "../components/ProductCard";

const Wishlist = () => {
  const { t } = useLang();
  const { wishlist } = useCart();

  return (
    <div className="pt-28 md:pt-36 pb-24 px-6 md:px-12 lg:px-24" data-testid="page-wishlist">
      <div className="grid lg:grid-cols-12 gap-10 items-end mb-14">
        <div className="lg:col-span-8">
          <p className="overline mb-4">{t.wishlist.title}</p>
          <h1 className="font-serif-display text-5xl md:text-6xl font-light text-[#1E2B3C] leading-[1.02]">
            {t.wishlist.title}
          </h1>
        </div>
      </div>

      {wishlist.length === 0 ? (
        <div className="py-24 text-center" data-testid="wishlist-empty">
          <p className="text-[#5C5C5C]">{t.wishlist.empty}</p>
          <Link to="/shop" className="btn-primary mt-8 inline-flex">
            {t.cart.emptyCta}
          </Link>
        </div>
      ) : (
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-x-5 gap-y-12 md:gap-x-8 md:gap-y-16">
          {wishlist.map((p, i) => (
            <ProductCard key={p.id} product={p} index={i} />
          ))}
        </div>
      )}
    </div>
  );
};

export default Wishlist;
